var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "app-main-inner-row",
          staticStyle: { "padding-top": "10px" }
        },
        [
          _c(
            "div",
            { staticClass: "filters" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "50px",
                    "label-position": "left"
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.filter.pageNum = 1
                      _vm.toQuery()
                    }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("common.btn.query") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "310px" },
                        attrs: {
                          no: "queryInput",
                          placeholder: _vm.$t("common.tips.fuzzySearch")
                        },
                        model: {
                          value: _vm.filter.likeName,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "likeName", $$v)
                          },
                          expression: "filter.likeName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "triggers" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.importVisible = true
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Import")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "query", type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.filter.pageNum = 1
                      _vm.toQuery()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "new", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.showEditDialog(true)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "edit", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.showEditDialog(false)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "delete", size: "mini", type: "danger" },
                  on: { click: _vm.remove }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        { staticClass: "app-main-inner-row row-grid" },
        [
          _c("cargo-ag-grid", {
            attrs: {
              no: "grid",
              "config-module": "250314",
              "grid-params": _vm.girdParams,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.girdParams = $event
              },
              "update:grid-params": function($event) {
                _vm.girdParams = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "app-main-inner-row row-pagination" },
        [
          _c("cargo-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total>0"
              }
            ],
            attrs: {
              no: "pagination",
              total: _vm.total,
              page: _vm.filter.pageNum,
              limit: _vm.filter.pageSize
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.filter, "pageNum", $event)
              },
              "update:limit": function($event) {
                return _vm.$set(_vm.filter, "pageSize", $event)
              },
              pagination: _vm.toQuery
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.editDialog.visible,
            title: _vm.editDialog.title,
            width: "680px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "80px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_Warehouse2"),
                            required: ""
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              "select-type":
                                _vm.selectTypeNames
                                  .basic_data_AirportCargoTerminal,
                              no: "airportCargoTerminalUuid",
                              filterable: "",
                              "method-params": {
                                dataType: 1,
                                deletionFlag: false
                              },
                              "default-value":
                                _vm.editDialog.form.airportCargoTerminalUuid,
                              "options-width": "200px"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.editDialog.form.airportCargoTerminalUuid =
                                  p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_PalletStatus"),
                            required: ""
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { filterable: "", no: "palletStatus" },
                              model: {
                                value: _vm.editDialog.form.palletStatus,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.editDialog.form,
                                    "palletStatus",
                                    $$v
                                  )
                                },
                                expression: "editDialog.form.palletStatus"
                              }
                            },
                            _vm._l(_vm.LOCATION_STATE_LIST, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.chineseName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_RecyclingType"),
                            required: ""
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { filterable: "", no: "recycleType" },
                              model: {
                                value: _vm.editDialog.form.recycleType,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.editDialog.form,
                                    "recycleType",
                                    $$v
                                  )
                                },
                                expression: "editDialog.form.recycleType"
                              }
                            },
                            _vm._l(_vm.RECYCLE_TYPE_LIST, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.chineseName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "100px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_PalletID"),
                            required: ""
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "palletCode" },
                            model: {
                              value: _vm.editDialog.form.palletCode,
                              callback: function($$v) {
                                _vm.$set(_vm.editDialog.form, "palletCode", $$v)
                              },
                              expression: "editDialog.form.palletCode"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_PalletMaterial"),
                            required: ""
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "200px" },
                              attrs: {
                                filterable: "",
                                clearable: "",
                                no: "palletMaterial"
                              },
                              model: {
                                value: _vm.editDialog.form.palletMaterial,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.editDialog.form,
                                    "palletMaterial",
                                    $$v
                                  )
                                },
                                expression: "editDialog.form.palletMaterial"
                              }
                            },
                            _vm._l(_vm.TRAY_MATERIAL_LIST, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.chineseName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_PalletTareWeight"),
                            required: ""
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("auto-number-input", {
                                staticStyle: { width: "180px" },
                                attrs: {
                                  no: "palletTareWeight",
                                  "enforce-min": true,
                                  precision: 0,
                                  min: 0
                                },
                                model: {
                                  value: _vm.editDialog.form.palletTareWeight,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editDialog.form,
                                      "palletTareWeight",
                                      $$v
                                    )
                                  },
                                  expression: "editDialog.form.palletTareWeight"
                                }
                              }),
                              _c("span", [_vm._v("KG")])
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "el-form",
            { attrs: { "label-width": "100px", "label-position": "right" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_RemarksInfo") } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: 3, no: "remarks" },
                    model: {
                      value: _vm.editDialog.form.remarks,
                      callback: function($$v) {
                        _vm.$set(_vm.editDialog.form, "remarks", $$v)
                      },
                      expression: "editDialog.form.remarks"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "save", type: "primary" },
                  on: { click: _vm.save }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmR")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.editDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("import-dialog", {
        attrs: {
          title: _vm.$t("CargoMsg.Cargo_Import"),
          action: _vm.URL.mdm.importPalletConfigurationUrl,
          visible: _vm.importVisible,
          "folder-name": "mdm",
          "file-name": "PalletConfigurationImport.xls"
        },
        on: {
          uploadSuccess: _vm.toQuery,
          onClose: function($event) {
            _vm.importVisible = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }